const InfoIcon = ({ color = '#9CA3AF' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.5" stroke={color} strokeWidth="1.3" />
    <path d="M8 7.25v3.5M8 5.5v.01" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
  </svg>
)

export default InfoIcon
